<template>
  <div class="navigtor">
    <div class="banner">
      <div class="navLeft" @click="goHome">
        <img src="@/assets/home/logo2.png" alt="">
        <span>Préstamo Boutique</span>
      </div>
      <div class="navRight">
        <div class="comisiones" @click="goComisiones">comisiones</div>
        <div class="home" @click="goHome">
          <img src="@/assets/home/home.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navigationPage',
  methods: {
    goHome () {
      if (this.$route.name === 'Home') {
        location.reload()
      } else {
        this.$router.replace({ name: 'Home' })
      }
    },
    goComisiones () {
      if (this.$route.name !== 'comisiones') {
        this.$router.push({ name: 'comisiones' })
      }
    }
  }

}
</script>

<style scoped lang="less">
/* 版心 */
.banner {
  width: 1100px;
  height: 100%;
  margin: auto;
}
/* 导航栏 */
.navigtor {
  width: 100%;
  height: 60px;
  background-color: #000000;
  .banner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .navLeft {
      height: 100%;
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #DFDFDF;
      img {
        width: 32px;
        height: 32px;
        margin-right: 10px;
      }
    }
    .navRight {
      display: flex;
      align-items: center;
      .comisiones{
        font-weight: 400;
        font-size: 20px;
        color: #E7FE48;
        margin-right: 116px;
        cursor: pointer;
      }
      .home{
        font-size: 0;
        cursor: pointer;
        img {
          width: 30px;
          height: 30px;
        }
      }
    }
  }
}
</style>
